<div class="form-group mt-0">
  <tabset>
    <tab
      *ngFor="let tab of field.options"
      (selectTab)="changeMessageTab(tab.key)"
      [active]="field.activeTab === tab.key"
    >
      <ng-template tabHeading>
        <div class="msg-count">
          <span>{{ tab.label }}</span>
          <p *ngIf="tab.count" class="msg-icon">{{ tab.count }}</p>
        </div>
      </ng-template>
    </tab>
  </tabset>
</div>
